<script setup>
import PanelHelp from '@/components/panel/Help.vue'

import { BUSINESS_NAVIGATION } from "@/constants/businessNavigation"

const route = useRoute()
const { can } = useBusinessAccess()
const items = computed(() => BUSINESS_NAVIGATION.filter(item => can(item.permission)))
const isActive = item => item.exact ? route.path === item.to : route.path.startsWith(item.to)
</script>

<template>
  <aside class="business-sidebar" aria-label="منوی مدیریت کسب‌وکار">
    <NuxtLink to="/client-page" class="business-sidebar__brand">
      <img src="/favicon-32x32.png" alt="">
      <div><strong>الومنشی</strong><small>پنل مدیریت کسب‌وکار</small></div>
    </NuxtLink>
    <nav>
      <NuxtLink v-for="item in items" :key="item.to" :to="item.to" :class="{ 'is-active': isActive(item) }">
        <span><VIcon :icon="item.icon" size="20" /></span>
        <div><strong>{{ item.title }}<PanelHelp v-if="isActive(item)" :label="item.title" fallback-tag="small" within-control>{{ item.description }}</PanelHelp></strong></div>
        <VIcon class="business-sidebar__arrow" icon="tabler-chevron-left" size="16" />
      </NuxtLink>
    </nav>
    <NuxtLink to="/client-page" class="business-sidebar__exit"><VIcon icon="tabler-arrow-right" size="19" />بازگشت به اپ مشتری</NuxtLink>
  </aside>
</template>

<style scoped lang="scss">
.business-sidebar { position: sticky; top: 0; display: flex; width: 266px; height: 100vh; flex: 0 0 266px; flex-direction: column; padding: 22px 14px 18px; border-left: 1px solid #eceaf3; background: rgba(255,255,255,.95); }
.business-sidebar__brand { display: flex; align-items: center; gap: 10px; margin: 0 7px 20px; color: #29243b; }
.business-sidebar__brand img { width: 42px; height: 42px; object-fit: contain; }
.business-sidebar__brand div { display: grid; gap: 2px; }
.business-sidebar__brand strong { font-size: 17px; }
.business-sidebar__brand small { color: #8c879a; font-size: 11px; }
.business-sidebar nav { display: grid; gap: 5px; overflow-y: auto; scrollbar-width: none; }
.business-sidebar nav a { display: grid; grid-template-columns: 39px minmax(0,1fr) 16px; align-items: center; gap: 9px; min-height: 64px; padding: 8px 9px; border-radius: 14px; color: #5d586b; transition: .2s ease; }
.business-sidebar nav a > span { display: grid; width: 37px; height: 37px; place-items: center; border-radius: 11px; color: #777185; background: #f5f3f9; }
.business-sidebar nav a div { display: grid; gap: 2px; }
.business-sidebar nav strong { font-size: 13px; }
.business-sidebar nav small { overflow: hidden; color: #9994a5; font-size: 10px; text-overflow: ellipsis; white-space: nowrap; }
.business-sidebar nav a:hover { background: rgba(var(--v-theme-primary), .055); }
.business-sidebar nav a.is-active { color: rgb(var(--v-theme-primary)); background: rgba(var(--v-theme-primary), .09); }
.business-sidebar nav a.is-active > span { color: #fff; background: linear-gradient(145deg, rgb(var(--v-theme-primary)), #8069ee); box-shadow: 0 6px 15px rgba(var(--v-theme-primary), .22); }
.business-sidebar__arrow { opacity: .45; }
.business-sidebar__exit { display: flex; align-items: center; justify-content: center; gap: 7px; margin-top: auto; padding: 12px; border: 1px solid #e8e5f0; border-radius: 13px; color: #666174; font-size: 12px; font-weight: 700; }
@media (max-width: 959px) { .business-sidebar { display: none; } }
</style>
